(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3342],{

/***/ 77135:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = __webpack_require__(88361);

var _classCallCheck = __webpack_require__(33227);

var _inherits = __webpack_require__(85971);

var _possibleConstructorReturn = __webpack_require__(52715);

var _getPrototypeOf = __webpack_require__(91193);

var _wrapNativeSuper = __webpack_require__(36558);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.DYNAMIC_ERROR_CODE = void 0;
var DYNAMIC_ERROR_CODE = 'DYNAMIC_SERVER_USAGE';
exports.DYNAMIC_ERROR_CODE = DYNAMIC_ERROR_CODE;

var DynamicServerError = /*#__PURE__*/function (_Error) {
  _inherits(DynamicServerError, _Error);

  var _super = _createSuper(DynamicServerError);

  function DynamicServerError(type) {
    var _this;

    _classCallCheck(this, DynamicServerError);

    _this = _super.call(this, "Dynamic server usage: ".concat(type));
    _this.digest = DYNAMIC_ERROR_CODE;
    return _this;
  }

  return _createClass(DynamicServerError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

exports.DynamicServerError = DynamicServerError;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 72128:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__(33227);

var _createClass = __webpack_require__(88361);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useSearchParams = useSearchParams;
exports.usePathname = usePathname;
Object.defineProperty(exports, "ServerInsertedHTMLContext", ({
  enumerable: true,
  get: function get() {
    return _serverInsertedHtml.ServerInsertedHTMLContext;
  }
}));
Object.defineProperty(exports, "useServerInsertedHTML", ({
  enumerable: true,
  get: function get() {
    return _serverInsertedHtml.useServerInsertedHTML;
  }
}));
exports.useRouter = useRouter;
exports.useSelectedLayoutSegments = useSelectedLayoutSegments;
exports.useSelectedLayoutSegment = useSelectedLayoutSegment;
Object.defineProperty(exports, "redirect", ({
  enumerable: true,
  get: function get() {
    return _redirect.redirect;
  }
}));
Object.defineProperty(exports, "notFound", ({
  enumerable: true,
  get: function get() {
    return _notFound.notFound;
  }
}));

var _react = __webpack_require__(67294);

var _appRouterContext = __webpack_require__(6163);

var _hooksClientContext = __webpack_require__(21203);

var _staticGenerationBailout = __webpack_require__(54013);

var _serverInsertedHtml = __webpack_require__(90334);

var _redirect = __webpack_require__(59580);

var _notFound = __webpack_require__(90052);

var INTERNAL_URLSEARCHPARAMS_INSTANCE = Symbol('internal for urlsearchparams readonly');

function readonlyURLSearchParamsError() {
  return new Error('ReadonlyURLSearchParams cannot be modified');
}

var ReadonlyURLSearchParams = /*#__PURE__*/function (_Symbol$iterator) {
  function ReadonlyURLSearchParams(urlSearchParams) {
    _classCallCheck(this, ReadonlyURLSearchParams);

    // Since `new Headers` uses `this.append()` to fill the headers object ReadonlyHeaders can't extend from Headers directly as it would throw.
    this[INTERNAL_URLSEARCHPARAMS_INSTANCE] = urlSearchParams;
    this.entries = urlSearchParams.entries.bind(urlSearchParams);
    this.forEach = urlSearchParams.forEach.bind(urlSearchParams);
    this.get = urlSearchParams.get.bind(urlSearchParams);
    this.getAll = urlSearchParams.getAll.bind(urlSearchParams);
    this.has = urlSearchParams.has.bind(urlSearchParams);
    this.keys = urlSearchParams.keys.bind(urlSearchParams);
    this.values = urlSearchParams.values.bind(urlSearchParams);
    this.toString = urlSearchParams.toString.bind(urlSearchParams);
  }

  _createClass(ReadonlyURLSearchParams, [{
    key: _Symbol$iterator,
    value: function value() {
      return this[INTERNAL_URLSEARCHPARAMS_INSTANCE][Symbol.iterator]();
    }
  }, {
    key: "append",
    value: function append() {
      throw readonlyURLSearchParamsError();
    }
  }, {
    key: "delete",
    value: function _delete() {
      throw readonlyURLSearchParamsError();
    }
  }, {
    key: "set",
    value: function set() {
      throw readonlyURLSearchParamsError();
    }
  }, {
    key: "sort",
    value: function sort() {
      throw readonlyURLSearchParamsError();
    }
  }]);

  return ReadonlyURLSearchParams;
}(Symbol.iterator);

function useSearchParams() {
  (0, _staticGenerationBailout).staticGenerationBailout('useSearchParams');
  var searchParams = (0, _react).useContext(_hooksClientContext.SearchParamsContext);

  if (!searchParams) {
    throw new Error('invariant expected search params to be mounted');
  }

  var readonlySearchParams = (0, _react).useMemo(function () {
    return new ReadonlyURLSearchParams(searchParams);
  }, [searchParams]);
  return readonlySearchParams;
}

function usePathname() {
  return (0, _react).useContext(_hooksClientContext.PathnameContext);
}

function useRouter() {
  var router = (0, _react).useContext(_appRouterContext.AppRouterContext);

  if (router === null) {
    throw new Error('invariant expected app router to be mounted');
  }

  return router;
} // TODO-APP: handle parallel routes


function getSelectedLayoutSegmentPath(tree, parallelRouteKey) {
  var first = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var segmentPath = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var node;

  if (first) {
    // Use the provided parallel route key on the first parallel route
    node = tree[1][parallelRouteKey];
  } else {
    // After first parallel route prefer children, if there's no children pick the first parallel route.
    var parallelRoutes = tree[1];

    var _children;

    node = (_children = parallelRoutes.children) != null ? _children : Object.values(parallelRoutes)[0];
  }

  if (!node) return segmentPath;
  var segment = node[0];
  var segmentValue = Array.isArray(segment) ? segment[1] : segment;
  if (!segmentValue) return segmentPath;
  segmentPath.push(segmentValue);
  return getSelectedLayoutSegmentPath(node, parallelRouteKey, false, segmentPath);
}

function useSelectedLayoutSegments() {
  var parallelRouteKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'children';

  var _useContext = (0, _react).useContext(_appRouterContext.LayoutRouterContext),
      tree = _useContext.tree;

  return getSelectedLayoutSegmentPath(tree, parallelRouteKey);
}

function useSelectedLayoutSegment() {
  var parallelRouteKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'children';
  var selectedLayoutSegments = useSelectedLayoutSegments(parallelRouteKey);

  if (selectedLayoutSegments.length === 0) {
    return null;
  }

  return selectedLayoutSegments[0];
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 90052:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.notFound = notFound;
exports.NOT_FOUND_ERROR_CODE = void 0;
var NOT_FOUND_ERROR_CODE = 'NEXT_NOT_FOUND';
exports.NOT_FOUND_ERROR_CODE = NOT_FOUND_ERROR_CODE;

function notFound() {
  // eslint-disable-next-line no-throw-literal
  var error = new Error(NOT_FOUND_ERROR_CODE);
  error.digest = NOT_FOUND_ERROR_CODE;
  throw error;
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 59580:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.redirect = redirect;
exports.REDIRECT_ERROR_CODE = void 0;
var REDIRECT_ERROR_CODE = 'NEXT_REDIRECT';
exports.REDIRECT_ERROR_CODE = REDIRECT_ERROR_CODE;

function redirect(url) {
  // eslint-disable-next-line no-throw-literal
  var error = new Error(REDIRECT_ERROR_CODE);
  error.digest = REDIRECT_ERROR_CODE + ';' + url;
  throw error;
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 54013:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.staticGenerationBailout = staticGenerationBailout;

var _hooksServerContext = __webpack_require__(77135);

var _staticGenerationAsyncStorage = __webpack_require__(99374);

function staticGenerationBailout(reason) {
  var staticGenerationStore = _staticGenerationAsyncStorage.staticGenerationAsyncStorage && 'getStore' in _staticGenerationAsyncStorage.staticGenerationAsyncStorage ? _staticGenerationAsyncStorage.staticGenerationAsyncStorage == null ? void 0 : _staticGenerationAsyncStorage.staticGenerationAsyncStorage.getStore() : _staticGenerationAsyncStorage.staticGenerationAsyncStorage;

  if (staticGenerationStore == null ? void 0 : staticGenerationStore.isStaticGeneration) {
    // TODO: honor the dynamic: 'force-static'
    if (staticGenerationStore) {
      staticGenerationStore.fetchRevalidate = 0;
    }

    throw new _hooksServerContext.DynamicServerError(reason);
  }
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 90334:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.useServerInsertedHTML = useServerInsertedHTML;
exports.ServerInsertedHTMLContext = void 0;

var _interop_require_wildcard = (__webpack_require__(91598)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(67294));

'use client';

var ServerInsertedHTMLContext = /*#__PURE__*/_react["default"].createContext(null);

exports.ServerInsertedHTMLContext = ServerInsertedHTMLContext;

function useServerInsertedHTML(callback) {
  var addInsertedServerHTMLCallback = (0, _react).useContext(ServerInsertedHTMLContext); // Should have no effects on client where there's no flush effects provider

  if (addInsertedServerHTMLCallback) {
    addInsertedServerHTMLCallback(callback);
  }
}

/***/ }),

/***/ 73342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AcademyMethods; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Icon/index.tsx + 2 modules
var Icon = __webpack_require__(83896);
// EXTERNAL MODULE: ./src/hooks/useTranslation.tsx + 1 modules
var useTranslation = __webpack_require__(85683);
// EXTERNAL MODULE: ./src/ui/SectionTitle/Title.tsx + 1 modules
var Title = __webpack_require__(83297);
// EXTERNAL MODULE: ./src/ui/Content/Content.tsx + 1 modules
var Content = __webpack_require__(74920);
// EXTERNAL MODULE: ./node_modules/next/navigation.js
var navigation = __webpack_require__(39332);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 8 modules
var polished_esm = __webpack_require__(96502);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 7 modules
var styled_components_browser_esm = __webpack_require__(50661);
// EXTERNAL MODULE: ./src/components/Icon/IconTemplate.tsx + 1 modules
var IconTemplate = __webpack_require__(67139);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/AcademyMethods/AcademyMethods.elements.tsx




var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyMethodselements__Wrapper",
  componentId: "sc-cmimvx-0"
})(["margin:", " 0 ", " 0;padding:", " 0;@media (min-width:", "px){display:flex;flex-direction:column;justify-content:space-between;}@media (min-width:", "px){padding:0;}"], (0,polished_esm/* rem */.hO)(0), (0,polished_esm/* rem */.hO)(45), (0,polished_esm/* rem */.hO)(30), theme/* breakpoints.sm */.A.sm, theme/* breakpoints.md */.A.md);
var Sections = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyMethodselements__Sections",
  componentId: "sc-cmimvx-1"
})(["font-size:", ";display:flex;flex-direction:column;"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSizes.h6;
});
var Section = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyMethodselements__Section",
  componentId: "sc-cmimvx-2"
})(["margin-bottom:", ";"], (0,polished_esm/* rem */.hO)(10));
var SectionHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyMethodselements__SectionHeader",
  componentId: "sc-cmimvx-3"
})(["display:flex;flex-direction:row;align-items:center;font-weight:", ";font-family:", ";svg{margin-right:", ";width:", ";height:", ";path{fill:", ";}}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeights.textBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fonts.fontSecondary;
}, (0,polished_esm/* rem */.hO)(14), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.primary;
});
var SectionDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyMethodselements__SectionDescription",
  componentId: "sc-cmimvx-4"
})(["padding-top:", ";padding-bottom:", ";color:", ";line-height:", ";strong{color:black;}"], (0,polished_esm/* rem */.hO)(0), (0,polished_esm/* rem */.hO)(20), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.grey;
}, (0,polished_esm/* rem */.hO)(30));
var TransportationOption = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyMethodselements__TransportationOption",
  componentId: "sc-cmimvx-5"
})(["border-bottom:1px solid ", ";padding-bottom:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.border;
}, (0,polished_esm/* rem */.hO)(10));
var TransportationHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyMethodselements__TransportationHeader",
  componentId: "sc-cmimvx-6"
})(["display:flex;flex-direction:row;justify-content:space-between;padding:", " 0;cursor:pointer;"], (0,polished_esm/* rem */.hO)(30));
var TransportationHeaderTexts = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyMethodselements__TransportationHeaderTexts",
  componentId: "sc-cmimvx-7"
})(["display:flex;flex-direction:column;gap:8px;"]);
var TransportationHeaderTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyMethodselements__TransportationHeaderTitle",
  componentId: "sc-cmimvx-8"
})(["font-size:", ";font-weight:600;color:", ";&.isOpen{color:", ";}"], (0,polished_esm/* rem */.hO)(18), function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.primary;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.primary;
});
var TransportationHeaderDesc = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyMethodselements__TransportationHeaderDesc",
  componentId: "sc-cmimvx-9"
})(["font-size:", ";line-height:", ";padding-right:", ";@media (min-width:", "px){padding-right:", ";}"], (0,polished_esm/* rem */.hO)(14), (0,polished_esm/* rem */.hO)(22), (0,polished_esm/* rem */.hO)(0), theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(100));
var TransportationHeaderRights = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyMethodselements__TransportationHeaderRights",
  componentId: "sc-cmimvx-10"
})(["padding-right:", ";gap:", ";display:flex;align-items:center;"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20));
var TransportationHeaderBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyMethodselements__TransportationHeaderBanner",
  componentId: "sc-cmimvx-11"
})(["font-size:", ";font-weight:600;border:1px solid ", ";border-radius:4px;color:", ";padding:", " ", ""], (0,polished_esm/* rem */.hO)(14), function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.primary;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.colors.primary;
}, (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(20));
var TransportationHeaderIcon = (0,styled_components_browser_esm/* default */.ZP)(IconTemplate/* IconTemplate */._).withConfig({
  displayName: "AcademyMethodselements__TransportationHeaderIcon",
  componentId: "sc-cmimvx-12"
})(["svg{width:", ";height:", ";}&.isOpen{svg{transform:rotate(180deg);}}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20));
var TransportationDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "AcademyMethodselements__TransportationDescription",
  componentId: "sc-cmimvx-13"
})(["padding:", " 0;line-height:", ";padding-left:", ";font-size:", ";.withBorder{text-decoration:underline;display:block;padding:", " 0;}.question{text-decoration:underline;}ul{padding-top:", ";padding-bottom:", ";}ol{padding-bottom:", ";}li{margin:", " 0;padding-bottom:", ";}a{color:", ";text-decoration:underline;}@media (min-width:", "px){padding-left:", ";}"], (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(24), (0,polished_esm/* rem */.hO)(10), (0,polished_esm/* rem */.hO)(16), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(20), (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(8), (0,polished_esm/* rem */.hO)(5), (0,polished_esm/* rem */.hO)(10), function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.primary;
}, theme/* breakpoints.sm */.A.sm, (0,polished_esm/* rem */.hO)(100));
var Link = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "AcademyMethodselements__Link",
  componentId: "sc-cmimvx-14"
})([""]);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/AcademyMethods/AcademyMethods.tsx









var METHODS = [{
  id: 1,
  question: 'Profivzdelavanie.sk',
  description: 'Možnosť začať študovať okamžite s cieľom získať <strong>oficiálne osvedčenie</strong>.'
}, {
  id: 2,
  question: 'Vzdelavamsa.sk (Ministerstvo školstva SR)',
  description: 'Pre zamestnaných aj nezamestnaných, ktorí chcú získať štátnu <strong>dotáciu a oficiálne osvedčenie</strong>.'
}, {
  id: 3,
  question: 'Ústredie práce, sociálnych vecí a rodiny SR',
  description: 'Pre záujemcov o zamestnanie evidovaných na úrade práce, ktorí si chcú zvýšiť šance na profesijné uplatnenie, <strong>získať oficiálne osvedčenie a príspevok na vzdelávanie v rámci projektu „Zručnosti pre trh práce“</strong>.'
}];

var AcademyMethodsTemplate = function AcademyMethodsTemplate() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var _useState = (0,react.useState)([]),
      openedAreas = _useState[0],
      setOpenedAreas = _useState[1];

  var searchParams = (0,navigation.useSearchParams)();
  (0,react.useEffect)(function () {
    var method = searchParams.get('program');

    if (method == 'profivzdelavanie') {
      toggleTransportationOption(1);
    } else if (method == 'vzdelavamsa') {
      toggleTransportationOption(2);
    } else if (method == 'upsvr') {
      toggleTransportationOption(3);
    }
  }, []);

  var toggleTransportationOption = function toggleTransportationOption(id) {
    if (openedAreas.includes(id)) {
      setOpenedAreas([]);
    } else {
      setOpenedAreas([]);
      setTimeout(function () {
        window.scrollTo({
          top: document.getElementById("".concat(id)).offsetTop - 120,
          behavior: 'smooth'
        });
        setOpenedAreas([id]);
      }, 50);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Content/* default */.Z, {
    mobileSidePadding: 20,
    id: "moznostAbsolvovania",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.C, {
      tagType: Title/* TitleTagTypes.H2 */.Z.H2,
      isBlack: true,
      children: t('academy.methods.title')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Sections, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Section, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SectionDescription, {
            dangerouslySetInnerHTML: {
              __html: t('academy.methods.description1')
            }
          })
        }), METHODS.map(function (area, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationOption, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationHeader, {
              id: "".concat(area.id),
              onClick: function onClick() {
                return toggleTransportationOption(area.id);
              },
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationHeaderTexts, {
                className: openedAreas.includes(area.id) ? 'isOpen' : 'isClose',
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(TransportationHeaderTitle, {
                  className: openedAreas.includes(area.id) ? 'isOpen' : 'isClose',
                  children: t(area.question)
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(TransportationHeaderDesc, {
                  className: openedAreas.includes(area.id) ? 'isOpen' : 'isClose',
                  dangerouslySetInnerHTML: {
                    __html: t(area.description)
                  }
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(TransportationHeaderRights, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(TransportationHeaderIcon, {
                  className: openedAreas.includes(area.id) ? 'isOpen' : 'isClose',
                  name: Icon/* Icons.ArrowDown */.PJ.ArrowDown
                })
              })]
            }), openedAreas.includes(area.id) && area.id == 1 && /*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationDescription, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                children: "Postup:"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                    children: "V\xFDber a n\xE1kup:"
                  }), " Vyberte si vzdel\xE1vac\xED program a\xA0uhra\u010Fte ho priamo na\xA0na\u0161ej webovej str\xE1nke profivzdelavanie.sk."]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                    children: "Aktiv\xE1cia:"
                  }), " Ihne\u010F po prip\xEDsan\xED platby v\xE1m za\u0161leme e-mail s\xA0pokynmi, ako sa m\xF4\u017Eete za\u010Da\u0165 vzdel\xE1va\u0165."]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                    children: "Vzdel\xE1vanie:"
                  }), " Teraz sa m\xF4\u017Eete naplno venova\u0165 vzdel\xE1vaniu."]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                    children: "Testovanie vedomost\xED:"
                  }), " Ak vzdel\xE1vac\xED program obsahuje viacero term\xEDnov \u0161kolen\xED, po\xA0ka\u017Edom z\xA0nich si over\xEDte vedomosti kr\xE1tkym testom. Po\xA0ukon\u010Den\xED programu v\xE1s \u010Dak\xE1 z\xE1vere\u010Dn\xFD test, v\xA0ktorom je potrebn\xE9 dosiahnu\u0165 aspo\u0148 75 %."]
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                    children: "Z\xEDskanie osved\u010Denia:"
                  }), " Po\xA0\xFAspe\u0161nom absolvovan\xED z\xE1vere\u010Dn\xE9ho testu v\xE1m vystav\xEDme ofici\xE1lne osved\u010Denie, ktor\xE9 zv\xFD\u0161i va\u0161u hodnotu na\xA0trhu pr\xE1ce."]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                children: "Upozornenie:"
              }), " Pri n\xE1kupe vzdel\xE1vacieho programu cez profivzdelavanie.sk nie je mo\u017En\xE9 uplatni\u0165 \u0161t\xE1tnu dot\xE1ciu."]
            }), openedAreas.includes(area.id) && area.id == 2 && /*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationDescription, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "V\xFD\u0161ka dot\xE1cie: A\u017E 200 \u20AC pr\xEDspevok"
                }), " na vzdel\xE1vac\xED program.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "O pr\xEDspevok m\xF4\u017Ee po\u017Eiada\u0165 z\xE1ujemca, ktor\xFD:"
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    children: "m\xE1 najmenej 16 rokov a v \u010Dase podania \u017Eiadosti nedov\u0155\u0161il 65 rokov,"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    children: "je ob\u010Danom SR alebo cudzincom s trval\xFDm pobytom, prechodn\xFDm pobytom, tolerovan\xFDm pobytom alebo s in\xFDm pobytom v SR,"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    children: "nie je \u017Eiakom strednej \u0161koly alebo \u0161tudentom vysokej \u0161koly v dennej forme \u0161t\xFAdia,"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    children: "nie je samostatne z\xE1robkovo \u010Dinnou osobou (SZ\u010CO). "
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "Upozornenie:"
                }), " Program je nutn\xE9 objedna\u0165 v\xFDhradne cez port\xE1l vzdelavamsa.sk. Pri priamom zak\xFApen\xED cez profivzdelavanie.sk nie je mo\u017En\xE9 uplatni\u0165 dot\xE1ciu dodato\u010Dne.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "Postup, ako uplatni\u0165 dot\xE1ciu:"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "1. Vyberte si vzdel\xE1vac\xED program"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: ["Na webovej str\xE1nke profivzdelavanie.sk si vyberte program, o ktor\xFD m\xE1te z\xE1ujem. Pozorne si pozna\u010Dte jeho n\xE1zov. N\xE1sledne prejdite na platformu ", /*#__PURE__*/(0,jsx_runtime.jsx)(Link, {
                  href: "https://vzdelavamsa.sk",
                  target: "_blank",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                    children: "vzdelavamsa.sk"
                  })
                }), ", kde prebieha administr\xE1cia dot\xE1ci\xED aj samotn\xE1 objedn\xE1vka.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "2. Registr\xE1cia na platforme vzdelavamsa.sk"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: ["Vytvorte si pou\u017E\xEDvate\u013Esk\xFD \xFA\u010Det na platforme vzdelavamsa.sk. K registr\xE1cii potrebujete platn\xFA e-mailov\xFA adresu a proces v\xE1m zaberie pribli\u017Ene 5 min\xFAt. Po \xFAspe\u0161nej registr\xE1cii a overen\xED identity z\xEDskate pr\xEDstup k spr\xE1ve va\u0161ich vzdel\xE1vac\xEDch aktiv\xEDt.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "3. Po\u017Eiadajte o pr\xEDspevok"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: ["Po prihl\xE1sen\xED do platformy vzdelavamsa.sk ihne\u010F uvid\xEDte v\xFD\u0161ku finan\u010Dn\xE9ho pr\xEDspevku, na ktor\xFD m\xE1te n\xE1rok. Vyh\u013Eadajte vami zvolen\xFD vzdel\xE1vac\xED program, ktor\xFD chcete absolvova\u0165 a prihl\xE1ste sa na\u0148. Syst\xE9m automaticky vygeneruje potrebn\xE9 dokumenty a \u017Eiadosti na ods\xFAhlasenie.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "4. \u010Cestn\xE9 vyhl\xE1senie a doru\u010Denie"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: ["Vytla\u010Dte \u010Destn\xE9 vyhl\xE1senie, ktor\xE9 n\xE1jdete vo svojom konte na vzdelavamsa.sk, overte ho u not\xE1ra a po\u0161lite ho po\u0161tou na\u0161ej vzdel\xE1vacej in\u0161tit\xFAcii na adresu: Poradca podnikate\u013Ea, spol. s r.o., Mgr. Dominika Chl\xE1dekov\xE1, PhD., Martina R\xE1zusa 23A, 01001, \u017Dilina.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "5. Absolvujte program cez profivzdelavanie.sk"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: ["Vzdel\xE1vanie prebieha online cez profivzdelavanie.sk alebo prezen\u010Dne na vopred dohodnutom mieste. Pred za\u010Dat\xEDm programu v\xE1m po\u0161leme e-mail s podrobn\xFDmi organiza\u010Dn\xFDmi pokynmi a in\u0161trukciami k \xFA\u010Dasti.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "6. Testovanie a \xFAspe\u0161n\xE9 ukon\u010Denie"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: ["Ak vzdel\xE1vac\xED program obsahuje viacero term\xEDnov \u0161kolen\xED, po ka\u017Edom z nich si over\xEDte vedomosti kr\xE1tkym testom. Po ukon\u010Den\xED programu v\xE1s \u010Dak\xE1 e\u0161te jeden z\xE1vere\u010Dn\xFD test, v ktorom mus\xEDte dosiahnu\u0165 aspo\u0148 75 %.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "7. Sp\xE4tn\xE1 v\xE4zba"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: ["Po ukon\u010Den\xED programu v\xE1m syst\xE9m ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "vzdelavamsa.sk"
                }), " za\u0161le \u017Eiados\u0165 o hodnotenie spokojnosti. Vyplnenie sp\xE4tnej v\xE4zby je povinn\xE9 \u2013 bez jej odoslania v\xE1m nebude mo\u017En\xE9 vystavi\u0165 osved\u010Denie.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "8. Z\xEDskanie osved\u010Denia"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: ["Po splnen\xED v\u0161etk\xFDch podmienok n\xE1jdete svoje ofici\xE1lne osved\u010Denie priamo vo svojom konte na vzdelavamsa.sk.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "9. Doplatok (ak cena prevy\u0161uje dot\xE1ciu)"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: ["V pr\xEDpade, \u017Ee cena programu prevy\u0161uje v\xFD\u0161ku schv\xE1lenej dot\xE1cie, rozdiel uhrad\xEDte na\u0161ej in\u0161tit\xFAcii na z\xE1klade fakt\xFAry, ktor\xFA v\xE1m vystav\xEDme. Splatnos\u0165 fakt\xFAry je 60 dn\xED.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              })]
            }), openedAreas.includes(area.id) && area.id == 3 && /*#__PURE__*/(0,jsx_runtime.jsxs)(TransportationDescription, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "V\xFD\u0161ka dot\xE1cie:"
                }), " Preplatenie vzdel\xE1vacieho programu ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "v plnej v\xFD\u0161ke"
                }), " po jeho \xFAspe\u0161nom absolvovan\xED."]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                children: "O pr\xEDspevok m\xF4\u017Ee po\u017Eiada\u0165 z\xE1ujemca o zamestnanie (ZoZ), ktor\xFD:"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  children: "je evidovan\xFD na \xFArade pr\xE1ce ako z\xE1ujemca o zamestnanie,"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  children: "nepodnik\xE1 ani nevykon\xE1va samostatn\xFA z\xE1robkov\xFA \u010Dinnos\u0165, "
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  children: "si h\u013Ead\xE1 nov\xE9 pracovn\xE9 uplatnenie alebo m\xE1 z\xE1ujem o vzdel\xE1vanie a poradensk\xE9 slu\u017Eby pre trh pr\xE1ce,"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  children: "nie je \u0161tudentom denn\xE9ho \u0161t\xFAdia, "
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  children: "nepober\xE1 starobn\xFD d\xF4chodok ani invalidn\xFD d\xF4chodok po dov\u0155\u0161en\xED d\xF4chodkov\xE9ho veku, "
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  children: "vyberie si vzdel\xE1vanie, ktor\xE9 s\xFAvis\xED s jeho bud\xFAcim uplatnen\xEDm na trhu pr\xE1ce,"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  children: "smeruje na profesiu, po ktorej je dopyt na trhu pr\xE1ce, "
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  children: "z\xEDska zru\u010Dnosti vyu\u017Eite\u013En\xE9 na trhu pr\xE1ce (napr. digit\xE1lne, zelen\xE9 alebo nedostatkov\xE9 profesie). "
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "Pr\xEDspevok nie je mo\u017En\xE9 z\xEDska\u0165 na:"
                }), " Obnovu alebo aktualiz\xE1ciu existuj\xFAcich zru\u010Dnost\xED, pr\xEDpadne na\xA0rovnak\xE9 alebo podobn\xE9 vzdel\xE1vanie, na\xA0ktor\xE9 u\u017E bol pr\xEDspevok poskytnut\xFD za\xA0posledn\xFDch 5 rokov."]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "Upozornenie:"
                }), " \u017Diados\u0165 o pr\xEDspevok mus\xEDte poda\u0165 najnesk\xF4r 30 kalend\xE1rnych dn\xED pred\xA0za\u010Diatkom vzdel\xE1vacieho programu. Dot\xE1ciu nie je mo\u017En\xE9 uplatni\u0165 sp\xE4tne na u\u017E prebiehaj\xFAci alebo ukon\u010Den\xFD vzdel\xE1vac\xED program.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "Postup, ako z\xEDska\u0165 a uplatni\u0165 pr\xEDspevok:"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "1. Sta\u0148te sa \u201Ez\xE1ujemcom o zamestnanie\u201C"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: ["Ak e\u0161te nie ste v evidencii, nav\u0161t\xEDvte ktor\xFDko\u013Evek \xFArad pr\xE1ce a podajte si ", /*#__PURE__*/(0,jsx_runtime.jsx)(Link, {
                  href: "https://www.upsvr.gov.sk/buxus/docs/SSZ/OISS/TLACIVA/2026/Ziadost_o_zaradenie_UoZ_od_01.01.2026.docx",
                  target: "_blank",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                    children: "\u201E\u017Diados\u0165 ZoZ o sprostredkovanie vhodn\xE9ho zamestnania\u201C"
                  })
                }), ". Bez tejto registr\xE1cie nie je mo\u017En\xE9 o pr\xEDspevok \u017Eiada\u0165.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "2. Vyberte si vzdel\xE1vac\xED program"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: ["Na na\u0161ej webovej str\xE1nke profivzdelavanie.sk si vyberte program, ktor\xFD v\xE1m pom\xF4\u017Ee pri zlep\u0161en\xED postavenia na trhu pr\xE1ce alebo pri zmene profesie.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "3. Vypl\u0148te \u017Eiados\u0165 o pr\xEDspevok"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: ["Stiahnite si formul\xE1r ", /*#__PURE__*/(0,jsx_runtime.jsx)(Link, {
                  href: "https://www.upsvr.gov.sk/buxus/docs/SSZ/OAOTP/ZpTP_ZoZ/Priloha_1__Ziadost_ZoZ.docx",
                  target: "_blank",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                    children: "\u201E\u017Diados\u0165 o poskytnutie pr\xEDspevku na podporu vzdel\xE1vania ZoZ\u201C"
                  })
                }), " alebo si ho vy\u017Eiadajte priamo na \xFArade.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "4. Pr\xEDprava povinnej pr\xEDlohy (Potvrdenie od n\xE1s)"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: ["K \u017Eiadosti o poskytnutie pr\xEDspevku potrebujete dolo\u017Ei\u0165 ", /*#__PURE__*/(0,jsx_runtime.jsx)(Link, {
                  href: "https://www.upsvr.gov.sk/buxus/docs/SSZ/OAOTP/ZpTP_ZoZ/Priloha_2_ZoZ_Potvrdenie_poskytovatela.docx",
                  target: "_blank",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                    children: "\u201EPotvrdenie poskytovate\u013Ea vzdel\xE1vania o zabezpe\u010Den\xED vzdel\xE1vania\u201C"
                  })
                }), ". Predvypl\u0148te v \u0148om svoje osobn\xE9 \xFAdaje a \xFAdaje o programe (vr\xE1tane formy a rozsahu) a po\u0161lite n\xE1m ho na e-mail: ", /*#__PURE__*/(0,jsx_runtime.jsx)(Link, {
                  href: "mailto:profivzdelavanie@pp.sk",
                  target: "_blank",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                    children: "profivzdelavanie@pp.sk"
                  })
                }), ". My dopln\xEDme zvy\u0161n\xE9 \xFAdaje v \u017Eiadosti.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "5. Potvrd\xEDme v\xE1m dokument a prilo\u017E\xEDme cenov\xFD prieskum"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: ["Fin\xE1lny dokument \u201EPotvrdenie poskytovate\u013Ea vzdel\xE1vania o zabezpe\u010Den\xED vzdel\xE1vania\u201C v\xE1m po\u0161leme na e-mail a prilo\u017E\xEDme k nemu povinn\xFD cenov\xFD prieskum (nie star\u0161\xED ako 3 mesiace), ktor\xFD vypracujeme za v\xE1s.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "6. Podajte \u017Eiados\u0165 na \xFArad (najnesk\xF4r 30 dn\xED pred kurzom)"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: "Kompletn\xFA \u201E\u017Diados\u0165 o poskytnutie pr\xEDspevku na podporu vzdel\xE1vania ZoZ\u201C spolu s na\u0161\xEDm potvrden\xEDm a cenov\xFDm prieskumom doru\u010Dte \xFAradu pr\xE1ce v mieste v\xE1\u0161ho trval\xE9ho pobytu (osobne, po\u0161tou alebo cez slovensko.sk)."
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: "Ak doru\u010Dujete \u017Eiados\u0165 cez port\xE1l slovensko.sk mus\xED by\u0165 \u017Eiados\u0165 podp\xEDsan\xE1 v\xFDlu\u010Dne kvalifikovan\xFDm elektronick\xFDm podpisom."
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: ["\u017Diados\u0165 mus\xED by\u0165 na \xFArade zaevidovan\xE1 najnesk\xF4r 30 kalend\xE1rnych dn\xED pred za\u010Diatkom vzdel\xE1vania. Rozhoduj\xFAci je d\xE1tum doru\u010Denia (zaevidovania v podate\u013Eni \xFAradu, resp. elektronick\xE9ho doru\u010Denia), nie d\xE1tum odoslania na po\u0161te.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "7. Po\u010Dkajte na schv\xE1lenie"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: ["Na pr\xEDspevok nie je automatick\xFD n\xE1rok. \xDArad pos\xFAdi, \u010Di m\xE1 kurz zmysel pre va\u0161u kari\xE9ru a \u010Di je cena vyhovuj\xFAca.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "8. Podpis dohody"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: "Po schv\xE1len\xED s vami \xFArad podp\xED\u0161e dohodu (osobne, elektronicky cez slovensko.sk alebo po\u0161tou). S\xFA\u010Das\u0165ou dohody s\xFA d\xF4le\u017Eit\xE9 pr\xEDlohy, ktor\xE9 budete e\u0161te potrebova\u0165:"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("ol", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    children: "Vzdel\xE1vac\xED poukaz"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    children: " \u017Diados\u0165 o \xFAhradu pr\xEDspevku na podporu vzdel\xE1vania z\xE1ujemcu o zamestnanie"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                    children: "Splnomocnenie na \xFAhradu ceny vzdel\xE1vania (kurzovn\xE9ho)"
                  })]
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "9. Vypl\u0148te \u017Diados\u0165 o \xFAhradu pr\xEDspevku"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: ["Vypl\u0148te \u201E\u017Diados\u0165 o \xFAhradu pr\xEDspevku na podporu vzdel\xE1vania z\xE1ujemcu o zamestnanie\u201C (pr\xEDloha k dohode) a starostlivo si ju uchovajte.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "10. Odovzdajte n\xE1m Vzdel\xE1vac\xED poukaz"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: ["Najnesk\xF4r v de\u0148 za\u010Datia vzdel\xE1vania ste povinn\xFD odovzda\u0165 n\xE1m Vzdel\xE1vac\xED poukaz (pr\xEDloha k dohode).", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "11. Absolvujte program a z\xEDskajte osved\u010Denie"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: ["Ak vzdel\xE1vac\xED program obsahuje viacero term\xEDnov \u0161kolen\xED, po ka\u017Edom z nich si over\xEDte vedomosti kr\xE1tkym testom. Po ukon\u010Den\xED programu v\xE1s \u010Dak\xE1 e\u0161te jeden z\xE1vere\u010Dn\xFD test, v ktorom mus\xEDte dosiahnu\u0165 aspo\u0148 75 %. N\xE1sledne v\xE1m vystav\xEDme ofici\xE1lne osved\u010Denie o absolvovan\xED, ktor\xE9 sl\xFA\u017Ei ako doklad pre \xFArad.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "12. Skompletizujte dokument\xE1ciu pre preplatenie"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: "Pre \xFAhradu kurzovn\xE9ho si pripravte tieto dokumenty:"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  children: "\u017Diados\u0165 o \xFAhradu pr\xEDspevku (z\xEDskali ste ako pr\xEDlohu k dohode)"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  children: "Fakt\xFAra za vzdel\xE1vanie (vystav\xEDme v\xE1m ju do 10 kalend\xE1rnych dn\xED od ukon\u010Denia vzdel\xE1vacieho programu)"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  children: "Osved\u010Denie o absolvovan\xED vzdel\xE1vania (k\xF3pia)"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
                  children: "Splnomocnenie na \xFAhradu ceny kurzovn\xE9ho \u2013 origin\xE1l (z\xEDskali ste ako pr\xEDlohu k dohode)"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
                  children: "13. Predlo\u017Ete \xFAradu \u017Eiados\u0165 o \xFAhradu pr\xEDspevku"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: "V\u0161etky dokumenty z bodu 12 doru\u010Dte \xFAradu najnesk\xF4r do 30 kalend\xE1rnych dn\xED od ukon\u010Denia vzdel\xE1vania, pri\u010Dom rozhoduj\xFAci je d\xE1tum doru\u010Denia \xFAradu (t. j. zaevidovania v podate\u013Eni \xFAradu, resp. elektronick\xE9ho doru\u010Denia). Po splnen\xED podmienok \xFArad uhrad\xED kurzovn\xE9 priamo na\u0161ej in\u0161tit\xFAcii do 30 dn\xED."
              })]
            })]
          }, key);
        })]
      })
    })]
  });
};

/* harmony default export */ var AcademyMethods = (AcademyMethodsTemplate);

/***/ }),

/***/ 39332:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(72128)


/***/ }),

/***/ 99374:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.staticGenerationAsyncStorage = void 0;
var staticGenerationAsyncStorage = {};
exports.staticGenerationAsyncStorage = staticGenerationAsyncStorage; // @ts-expect-error we provide this on globalThis in
// the edge and node runtime

if (globalThis.AsyncLocalStorage) {
  exports.staticGenerationAsyncStorage = staticGenerationAsyncStorage = new globalThis.AsyncLocalStorage();
}

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ })

}]);